import salesagentSlice from "../slices/salesagentSlice";

export const salesagentReducers = {
  salesagent: salesagentSlice,
};
